/**
 * Pop-up de bienvenida (Pop Convert) en el idioma de cada tienda.
 *
 * La campaña «Nuevos suscriptores» de Pop Convert (-5 %, cupón NUEVO2025) solo
 * tiene un texto, en español, y la app no sabe servir otro según el idioma: su
 * campo de traducciones está vacío y el script del escaparate ni lo lee. Así
 * que salía en español en fr., pt., de., it., nl., be. y lu.tiendamanilla.com,
 * y el contador ponía «Hours / Min / Sec» en inglés incluso en España.
 *
 * Aquí se traduce lo que pinta, ya dentro de la página: Pop Convert lo mete en
 * un shadow DOM abierto (#pop-convert-app) y se cambia cada texto que coincida
 * EXACTAMENTE con uno de la lista. El idioma es el de la página (Shopify.locale),
 * no el país del visitante.
 *
 * Si se cambia un texto de la campaña en Pop Convert, hay que cambiar aquí la
 * clave: mientras no coincida, ese texto sale tal cual está en la app (en
 * español), nunca roto. Lo que no está en la lista (el código del cupón, los
 * números del contador) no se toca.
 */
(function () {
  'use strict';

  // Clave = texto tal cual lo pinta Pop Convert (sin espacios a los lados).
  var TEXTOS = {
    es: {
      'Days': 'Días',
      'Hours': 'Horas',
      'Sec': 'Seg',
      'Copied!': '¡Copiado!'
    },
    fr: {
      '-5% DTO': '-5\u00a0% DE\u00a0REMISE',
      'Suscríbete': 'Abonnez-vous',
      'Days': 'Jours',
      'Hours': 'Heures',
      'Email': 'E-mail',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'J’accepte de m’abonner à cette newsletter et de recevoir des communications.',
      'Enviar': 'Envoyer',
      '¡Gracias por tu interés!': 'Merci de votre intérêt\u00a0!',
      'Cerrar': 'Fermer',
      'Copied!': 'Copié\u00a0!'
    },
    pt: {
      '-5% DTO': '-5% DESCONTO',
      'Suscríbete': 'Subscreva',
      'Days': 'Dias',
      'Hours': 'Horas',
      'Sec': 'Seg',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'Aceito subscrever esta newsletter e receber comunicações.',
      '¡Gracias por tu interés!': 'Obrigado pelo seu interesse!',
      'Cerrar': 'Fechar',
      'Copied!': 'Copiado!'
    },
    de: {
      '-5% DTO': '-5\u00a0% RABATT',
      'Suscríbete': 'Jetzt abonnieren',
      'Days': 'Tage',
      'Hours': 'Stunden',
      'Sec': 'Sek',
      'Email': 'E-Mail',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'Ich stimme zu, diesen Newsletter zu abonnieren und Mitteilungen zu erhalten.',
      'Enviar': 'Senden',
      '¡Gracias por tu interés!': 'Vielen Dank für Ihr Interesse!',
      'Cerrar': 'Schließen',
      'Copied!': 'Kopiert!'
    },
    it: {
      '-5% DTO': '-5% SCONTO',
      'Suscríbete': 'Iscriviti',
      'Days': 'Giorni',
      'Hours': 'Ore',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'Accetto di iscrivermi a questa newsletter e di ricevere comunicazioni.',
      'Enviar': 'Invia',
      '¡Gracias por tu interés!': 'Grazie per il tuo interesse!',
      'Cerrar': 'Chiudi',
      'Copied!': 'Copiato!'
    },
    nl: {
      '-5% DTO': '-5% KORTING',
      'Suscríbete': 'Schrijf je in',
      'Days': 'Dagen',
      'Hours': 'Uur',
      'Email': 'E-mail',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'Ik ga ermee akkoord me in te schrijven voor deze nieuwsbrief en berichten te ontvangen.',
      'Enviar': 'Verzenden',
      '¡Gracias por tu interés!': 'Bedankt voor je interesse!',
      'Cerrar': 'Sluiten',
      'Copied!': 'Gekopieerd!'
    },
    en: {
      '-5% DTO': '5% OFF',
      'Suscríbete': 'Subscribe',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'I agree to subscribe to this newsletter and receive communications.',
      'Enviar': 'Send',
      '¡Gracias por tu interés!': 'Thank you for your interest!',
      'Cerrar': 'Close'
    },
    pl: {
      '-5% DTO': '-5% RABATU',
      'Suscríbete': 'Zapisz się',
      'Days': 'Dni',
      'Hours': 'Godz.',
      'Sec': 'Sek',
      'Email': 'E-mail',
      'Acepto suscribirme a esta newsletter y recibir comunicaciones.': 'Wyrażam zgodę na zapis do tego newslettera i otrzymywanie wiadomości.',
      'Enviar': 'Wyślij',
      '¡Gracias por tu interés!': 'Dziękujemy za zainteresowanie!',
      'Cerrar': 'Zamknij',
      'Copied!': 'Skopiowano!'
    }
  };

  var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
  var textos = TEXTOS[locale.slice(0, 2).toLowerCase()];
  if (!textos) return;

  var ATRIBUTOS = ['placeholder', 'aria-label', 'title'];

  function traducir(valor) {
    var limpio = valor.trim();
    if (!limpio || !Object.prototype.hasOwnProperty.call(textos, limpio)) return null;
    // Se conservan los espacios de alrededor para no pegar palabras.
    return valor.replace(limpio, textos[limpio]);
  }

  function traducirTexto(nodo) {
    var nuevo = traducir(nodo.nodeValue);
    // Solo si cambia: escribir lo mismo volvería a disparar el observador.
    if (nuevo !== null && nuevo !== nodo.nodeValue) nodo.nodeValue = nuevo;
  }

  function traducirAtributos(el) {
    for (var i = 0; i < ATRIBUTOS.length; i++) {
      var valor = el.getAttribute(ATRIBUTOS[i]);
      if (!valor) continue;
      var nuevo = traducir(valor);
      if (nuevo !== null && nuevo !== valor) el.setAttribute(ATRIBUTOS[i], nuevo);
    }
  }

  function barrer(raiz) {
    if (raiz.nodeType === 3) return traducirTexto(raiz);
    if (raiz.nodeType === 1) {
      // Los <style> de la app son CSS, no texto visible.
      if (raiz.tagName === 'STYLE' || raiz.tagName === 'SCRIPT') return;
      traducirAtributos(raiz);
    }
    if (!raiz.querySelectorAll) return;

    var paseo = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
    var nodo;
    while ((nodo = paseo.nextNode())) {
      var padre = nodo.parentNode;
      if (padre && (padre.nodeName === 'STYLE' || padre.nodeName === 'SCRIPT')) continue;
      traducirTexto(nodo);
    }
    var conAtributos = raiz.querySelectorAll('[placeholder],[aria-label],[title]');
    for (var i = 0; i < conAtributos.length; i++) traducirAtributos(conAtributos[i]);
  }

  function vigilar(sombra) {
    barrer(sombra);
    // El pop-up se monta al dispararse (salida de la página) y cambia de
    // pantalla al suscribirse: se traduce cada cosa nueva según aparece.
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var cambio = cambios[i];
        if (cambio.type === 'characterData') {
          traducirTexto(cambio.target);
        } else if (cambio.type === 'attributes') {
          traducirAtributos(cambio.target);
        } else {
          for (var j = 0; j < cambio.addedNodes.length; j++) barrer(cambio.addedNodes[j]);
        }
      }
    }).observe(sombra, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATRIBUTOS
    });
  }

  function buscarApp() {
    var app = document.getElementById('pop-convert-app');
    return app && app.shadowRoot;
  }

  var sombra = buscarApp();
  if (sombra) return vigilar(sombra);
  if (!window.MutationObserver) return;

  // El script de Pop Convert carga asíncrono: se espera a que cree su caja.
  var espera = new MutationObserver(function () {
    var encontrada = buscarApp();
    if (!encontrada) return;
    espera.disconnect();
    vigilar(encontrada);
  });
  espera.observe(document.documentElement, { childList: true, subtree: true });
})();
